import React from "react";
import Bloomberg from "./institutionImages/bloomberg.svg";
import Credit from "./institutionImages/credit-suisse-logo.svg";
import HSBC from "./institutionImages/hsbc.svg";
import Money from "./institutionImages/moneygram-logo.svg";
import Howden from "./institutionImages/howden.svg";
import KPMG from "./institutionImages/kpmg.svg";
import EY from "./institutionImages/ernst-youngsvg.svg";
import RBC from "./institutionImages/rbc.svg";
import NYC from "./institutionImages/newyorklife.svg";

function InstitutionIcons() {
  return (
    <div className="bg-darkBlue py-10">
      <div className="flex-col w-full 2xl:w-6/12 justify-center mx-auto">
        <h2 className="font-bold text-[#e6e6e6] text-[35px] leading-relaxed text-center font-secondary">
          Financial Translation Services{" "}
          <span className="text-lightBlue">Trusted</span> by Financial
          Institutions Worldwide
        </h2>
        <div className="grid w-full grid-rows-4 grid-cols-2 md:grid-cols-3 px-4 gap-x-40 gap-y-14 pt-24 mx-auto justify-items-center">
          <img src={Bloomberg} alt="" />
          <img src={Credit} alt="" />
          <img src={HSBC} alt="" />
          <img src={Money} alt="" />
          <img src={Howden} alt="" />
          <img src={KPMG} alt="" />
          <img src={EY} alt="" />
          <img src={RBC} alt="" />
          <img src={NYC} alt="" />
        </div>
      </div>
    </div>
  );
}

export default InstitutionIcons;
